<template>
  <el-row class="panel m-w-1280">
    <div class="panel-top m-w-1280 common-header" >
      <el-row type="flex" justify="space-between" class="p-lf-30 m-w-1280" >
        <el-row type="flex" align="middle" style="flex: 1;" class="common-header-row">
          <div class="common-header-img" v-show="systemImg"><img :src="systemImg" /></div>
          <div class="separator" v-show="systemImg"></div>
          <div class="fz-20 fw-b c-black common-header-name">{{ systemName }}</div>
          <el-row type="flex" style="max-width: 1000px;">
            <div class="top-menu" :class="{'top-active': menu.selected}" v-for="menu in topMenu" @click="switchTopMenu(menu)">{{menu.title}}</div>
          </el-row>
        </el-row>
        <el-row type="flex" :class="{ 'm-r-60': !isSmall, 'm-r-40': isSmall }">
          <span class="c-999 fz-16">欢迎回来，{{username}}</span>
        </el-row>
        <el-row type="flex" align="middle">
          <div>
            <div class="fz-14">
              <router-link :to="{ name: 'messageCenter' }">
                <el-badge :is-dot="isUnRead" class="item">
                  <span class="top-icon"><i class="iconfont icon-message"></i></span>
                </el-badge>
              </router-link>
            </div>
          </div>
          <div>
            <el-dropdown @command="handleMenu">
              <!--<span class="el-dropdown-link c-black fz-18">{{username}}&nbsp;&nbsp;<i class="fa fa-user c-999" aria-hidden="true"></i></span>-->
              <span class="top-icon m-r-16 m-l-20"><i class="iconfont icon-user"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
                  <el-dropdown-item command="logout">退出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-row>
      </el-row>
    </div>
    <el-col :span="24" class="panel-center" :class="{ 't-70': !isSmall, 't-60': isSmall }">
      <!--<el-col :span="4">-->
      <aside id="leftMenu" class="w-200 ovf-auto mh-100p" :style="{ width: mediaWidth + 'px!important' }" v-show="!showLeftMenu">
        <leftMenu :menuData="menuData" :menu="menu" :secId="secId" :thirdId="thirdId" ref="leftMenu" @setActiveId="setActiveId"></leftMenu>
      </aside>
      <section class="panel-c-c" id='panelContent' :class="{'hide-leftMenu': hasChildMenu, 'panel-c-c-no':isFlow }" :style="{ left: mediaWidth + 'px!important' }">
        <div class="grid-content bg-purple-light">
          <el-col :span="24">
            <transition name="fade" mode="out-in" appear>
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>

      <changePwd ref="changePwd"></changePwd>
    </el-row>
</template>
<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  .top-icon {
    color: #c8c8c8;
    cursor: pointer;
    font-size: 20px;
  }
  .top-icon i {
    display: inline-block;
    text-align: center;
    width: 24px;
    height: 23px;
  }
  .top-icon:hover {
    color: #20A0FF;
  }

  .panel {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
  }

  .panel-top {
    position: absolute;
    left: 0;
    right: 0;
    background: #ffffff;
    color: #333333;
    box-shadow: 0 2px 6px 0 rgba(0,0,0,.1);
    -webkit-box-shadow: 0 2px 6px 0 rgba(0,0,0,.1);
    -moz-box-shadow: 0 2px 6px 0 rgba(0,0,0,.1);
    -o-box-shadow: 0 2px 6px 0 rgba(0,0,0,.1);
    -ms-box-shadow: 0 2px 6px 0 rgba(0,0,0,.1);
    z-index: 10;
  }

  .panel-top .separator {
    height: 24px;
    border-left: 1px solid #e5e5e5;
    margin: 0 20px;
  }

  .panel-center {
    background: #0e1520;
    position: absolute;
    bottom: 0px;
    overflow: hidden;
  }

  .panel-c-c {
    background: #f1f2f7;
    position: absolute;
    right: 0px;
    top: 0px;
    bottom: 0px;
    left: 230px;
    overflow-y: scroll;
    padding: 20px;
  }
  .panel-c-c-no{
    padding: 0;
  }
  .logout {
    background: url(../assets/images/logout_36.png);
    background-size: contain;
    width: 20px;
    height: 20px;
    float: left;
  }

  .logo {
    width: 150px;
    float: left;
    /*margin: 10px 10px 10px 18px;*/
  }

  .tip-logout {
    float: right;
    margin-right: 20px;
    padding-top: 5px;
    cursor: pointer;
  }

  .admin {
    color: #c0ccda;
    text-align: center;
  }
  .hide-leftMenu {
    left: 0px;
  }
  .el-input__inner {
    border-radius: 0 !important;
    border: 1px solid #d7d7d7 !important;
    outline: none;
  }
  .el-form-item {
    margin-bottom: 30px !important;
  }
  .el-button--small {
    padding: 7px 12px !important;
  }
  .fa {
    font-size: 16px;
    vertical-align: middle;
    margin-bottom: 2px;
  }
  .common-header{
    height: 70px!important;
    font-size: 18px!important;
    line-height: 70px!important;
  }
  .common-header .common-header-row{
      height:70px!important;
      line-height: 70px!important;
  }
  .common-header .common-header-img, 
  .common-header .common-header-img img{
    height: 40px!important;
    line-height: 40px!important;
  }
  .common-header .common-header-name{
    margin-right: 200px;
  }
  .common-header .top-menu{
    margin-right: 60px;
  }
  @media screen and (max-width: 1600px) {
    .common-header {
      height:60px!important;
      font-size: 16px!important;
      line-height: 60px!important;
    }
    .common-header .common-header-row{
      height:60px!important;
      line-height: 60px!important;
    } 
    .common-header .common-header-img, 
    .common-header .common-header-img img{
      height: 30px!important;
      line-height: 30px!important!important;
    }
    .common-header .common-header-name{
      margin-right: 60px;
    }
    .common-header .top-menu{
      margin-right: 30px;
    }
  }
  
</style>
<script>
  import leftMenu from './Common/normal/leftMenu.vue'
  import changePwd from './Account/changePwd.vue'
  import http from '../assets/js/http'
  import '../assets/css/icon.css'

  export default {
    data() {
      return {
        username: '',
        topMenu: [],
        menusThreeList: [],
        menuData: [],
        hasChildMenu: false,
        isFlow: false,
        menu: null,
        module: null,
        systemImg: '',
        systemName: '',
        secId: '',
        thirdId: '',
        mediaWidth: 0,
        isSmall: false,
        screenWidth: document.body.clientWidth, // 获取屏幕初始宽度
        screenTimer: false,
        readTimeOut: null, // 消息定时器
        isUnRead: false // 是否有未读消息
      }
    },
    methods: {
      // 退出登录
      logout() {
        this.$confirm('确认退出吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.apiGet('admin/users/logout').then((res) => {
            if (res.code == 200) {
              Lockr.rm('menus')
              Lockr.rm('menusThreeList')
              Lockr.rm('rememberKey')
              Lockr.rm('authList')
              Lockr.rm('userInfo')
              Lockr.rm('token')
              Cookies.remove('rememberPwd')
              _g.toastMsg(this, 'success', '退出成功')
              setTimeout(() => {
                router.replace('/')
              }, 1500)
            } else {
              _g.dealError(this, res)
            }
          })
        })
      },
      getCommonData() {
        this.apiGet('admin/rules').then((res) => {
          if (res.code == 200) {
            store.dispatch('setRules', res.data)
          } else {
            _g.dealError(this, res)
          }
        })
        this.apiGet('admin/structures').then((res) => {
          if (res.code == 200) {
            store.dispatch('setOrganizes', res.data)
          } else {
            _g.dealError(this, res)
          }
        })
        this.apiGet('admin/groups').then((res) => {
          if (res.code == 200) {
            store.dispatch('setUserGroups', res.data)
          } else {
            _g.dealError(this, res)
          }
        })
      },
      switchTopMenu(item) {
        if (!item.child && item.url) {
          router.push(item.url)
          store.dispatch('showLeftMenu', true)
        } else if (item.child.length &&
            item.child[0].child &&
            item.child[0].child.length &&
            item.child[0].child[0].url) {
          router.push(item.child[0].child[0].url)
          store.dispatch('showLeftMenu', false)
        } else {
          _g.toastMsg(this, 'error', '菜单不存在')
        }
      },
      handleMenu(val) {
        switch (val) {
          case 'logout':
            this.logout()
            break
          case 'changePwd':
            this.changePwd()
            break
        }
      },
      changePwd() {
        this.$refs.changePwd.open()
      },
      getTitleAndLogo() {
        this.apiPost('admin/base/getConfigs').then((res) => {
          if (res.code == 200) {
            document.title = res.data.SYSTEM_NAME
            this.systemName = res.data.SYSTEM_NAME
            this.systemImg = !_g.isRealEmpty(res.data.SYSTEM_LOGO) ? window.imgUrl + res.data.SYSTEM_LOGO : ''
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getUsername() {
        this.username = Lockr.get('userInfo').username
      },
      getCurrentModule(url) {
        let module = ''
        let contentId = this.$route.params.contentId
        module = this.$route.meta.module
        if (!module) {
          _(this.menusThreeList).forEach((res) => { // 判断当前url是否存在三级菜单中
            if (url == res.url) {
              module = res.module
              return false
            }
            if (contentId && res.content_id == contentId) { // 判断当前contentId是否与菜单contentId相同
              _(this.topMenu).forEach((item) => {
                if (item.id == res.top_id) {
                  module = item.module
                  if (res.sec_id && res.third_id) {
                    this.secId = res.sec_id
                    this.thirdId = res.third_id
                  }
                  return false
                }
              })
              return false
            }
          })
        }
        if (!module) {
          _(this.topMenu).forEach((item) => { // 判断当前url是否存在于顶部（单页）菜单中
            if (url == item.url) {
              module = item.module
              return false
            }
          })
        }
        return module
      },
      setActiveId(secId, thirdId) {   // 设置当前激活的二级和三级菜单
        this.secId = secId
        this.thirdId = thirdId
      },
      refreshMenus() {
        let menus = Lockr.get('menus')
        this.menusThreeList = Lockr.get('menusThreeList')
        this.menu = this.$route.meta.menu
        // this.module = this.$route.meta.module
        this.topMenu = menus
        this.module = this.getCurrentModule(this.$route.path)
        let hasMatch = false
        _(menus).forEach((res) => {
          if (res.module == this.module) {
            hasMatch = true
            this.menuData = res.child
            if (!res.child && res.url) {
              store.dispatch('showLeftMenu', true)
            } else {
              if (this.$route.meta.hideLeft !== '') {
                store.dispatch('showLeftMenu', this.$route.meta.hideLeft)
              } else {
                store.dispatch('showLeftMenu', false)
              }
            }
            res.selected = true
          } else {
            res.selected = false
          }
        })
        if (!hasMatch) {
          this.menuData = menus[0].child
          if (!menus[0].child && menus[0].url) {
            store.dispatch('showLeftMenu', true)
          } else {
            if (this.$route.meta.hideLeft !== '') {
              store.dispatch('showLeftMenu', this.$route.meta.hideLeft)
            } else {
              store.dispatch('showLeftMenu', false)
            }
          }
        }
      },
      initMenuWidth() {
        if (!this.hasChildMenu) {
          if (this.screenWidth > 1280 && this.screenWidth < 1920) {
            this.mediaWidth = this.screenWidth / 8
          } else if (this.screenWidth >= 1920) {
            this.mediaWidth = 200
          } else if (this.screenWidth <= 1280) {
            this.mediaWidth = 160
          }
        }
        if (this.screenWidth <= 1500) {
          this.isSmall = true
        }
      },
      checkUnReadMessage() {
        let self = this
        if (self.readTimeOut) {
          clearInterval(readTimeOut)
        }
        self.readTimeOut = setInterval(() => {
          store.dispatch('setMessageUnRead')
        }, 10000)
      }
    },
    created() {
      this.getTitleAndLogo()
      if (!Lockr.get('token')) {
        _g.toastMsg(this, 'warning', '您尚未登录')
        setTimeout(() => {
          router.replace('/')
        }, 1500)
        return
      }
      // this.getCommonData()
      _g.updateMenus()
      this.checkUnReadMessage()
      this.getUsername()
      this.refreshMenus()
      if (this.$route.meta.isFlow) {
        this.isFlow = true
      } else {
        this.isFlow = false
      }
    },
    computed: {
      routerShow() {
        return store.state.routerShow
      },
      showLeftMenu() {
        this.hasChildMenu = store.state.showLeftMenu
        if (this.hasChildMenu) {
          this.mediaWidth = 0
        }
        this.initMenuWidth()
        return store.state.showLeftMenu
      }
    },
    components: {
      leftMenu,
      changePwd
    },
    watch: {
      '$route' (to, from) {               // 监听路由改变
        let currentModule = this.getCurrentModule(to.path)
        if (to.meta.isFlow) {
          this.isFlow = true
        } else {
          this.isFlow = false
        }
        // let currentModule = to.meta.module
        _(this.topMenu).forEach((res) => {
          if (res.module == currentModule) {
            res.selected = true
            if (!to.meta.hideLeft) {
              this.menu = to.meta.menu
              this.menuData = res.child
            }
            this.menuData = res.child
            if (!res.child && res.url) {
              store.dispatch('showLeftMenu', true)
            } else {
              store.dispatch('showLeftMenu', to.meta.hideLeft)
            }
          } else {
            res.selected = false
          }
        })
      },
      '$store.state.menusUpdate'() {
        if (store.state.menusUpdate) {
          Lockr.set('menus', store.state.menusList)
          Lockr.set('menusThreeList', store.state.menusThreeList)
          store.dispatch('setMenusUpdate', false)
          this.refreshMenus()
        }
      },
      '$store.state.isUnRead'() {
        if (store.state.isUnRead !== undefined) {
          this.isUnRead = store.state.isUnRead
        }
      },
      screenWidth(val) {
        this.initMenuWidth()
      }
    },
    mixins: [http],
    mounted() {
      const self = this
      window.onresize = () => {
        window.screenWidth = document.body.clientWidth
        self.screenWidth = window.screenWidth
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Home.vue?1cb60738